import styled from "styled-components";
import theme from "../../constants/globalStyles/theme.json";

const { spacing, radius, breakpoints } = theme;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  padding: ${spacing.space24};
  padding-bottom: 280px;
  gap: ${spacing.space32};
  max-width: 1440px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.l}) {
    gap: ${spacing.space24};
  }
`;

export const ContactInformation = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e6e0ca;
  padding: ${spacing.space32};
  border-radius: ${radius.large};
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
  max-width: 600px;

  @media (max-width: ${breakpoints.s}) {
    padding: ${spacing.space24};
    max-width: 100%;
  }
`;
